import { IProductSettings } from "../../repository/IProductSettings";

export const getCategoryProducts = ( payload: IProductSettings, name?: string) => ({
  type: "@saga/GET_CATEGORY_PRODUCTS",
  payload: { payload, name },
});
